import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import moment from 'moment'
import React, { Component } from 'react'
import Modal1 from 'react-awesome-modal'
import { Modal } from 'react-bootstrap'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Grid from '@material-ui/core/Grid'
import axios from 'axios'
import customStyle from '../../../components/healthqn/CSS/stylesheet_UHS'
import CommonDropDwn from '../Transaction/CommonDropDwn'
import {
  createCase,
  getAccountNumber,
  getCardEnableData,
  getNeoTransactionMobile,
  getPaymentType,
  getRecurringDateData,
  MobilegetTransactionData
} from '../../ApiCall'
import CommonLoader from '../../CommonLoader'
import ChatIcon from '../../WebScreen/ChatBox/ChatIcon'
import MobCopyright from '../MobCopyright'
import SimpleAccordion from '../MobileCommonComponents/SimpleAccordion'
import MobileHeader from '../MobileHeader'
import MobileFooter from './../MobileFooter'
import { isVeraMember } from '../../VeraApiCall'

const NextButton = withStyles(customStyle.viewBtn)(Button)

export default class MyNeedsMobile extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      response: [],
      formatedjsonData: null,
      page: 0,
      loader: true,
      loadMoreBtnshow: false,
      notfoundmsg: '',
      tempNotAvailableModal: false,
      accountNo: '',
      paymentData: [],
      paymentDatamodel: {},
      expanded: 'panel2',
      openChangeBillingModal:false,
      responseText:"",
      draftDayModal: false,
      currentMonthDays: [],
      selectedBillingDay: '',
      currentMonthName: '',
      nextRecurringDate: '',
      sourceCode: localStorage.getItem('sourceid'),
    }
  }

  componentDidMount() {
    this.setState({ loader: true })
    // this.getCardEnable()
    if (localStorage.getItem('SOURCE') === 'NEO') {
      this.getNeoTransaction()
    } else {
      this.callapi()
    }
    this.getAccountNumber()
    this.getPayType(localStorage.getItem('sourceid'))
    this.getPaymentData()
    // this.createjson()
  }

  callapi() {
    MobilegetTransactionData(this.state.page).then(res => {
      if (res.data.response.length > 0) {
        if (res.data.response[0].totalRecord > 10) {
          this.setState({ loadMoreBtnshow: true })
        } else {
          this.setState({ loadMoreBtnshow: false })
        }
        this.setState({ response: res.data.response, page: this.state.page + 1, loader: false })
      } else {
        this.setState({ notfoundmsg: 'My Transactions Data Not Available', loader: false })
      }
      this.createjson()
    })
  }

  getNeoTransaction = () => {
    getNeoTransactionMobile(this.state.page).then(res => {
      if (res.data.totalrecords > 0) {
        this.setState({ response: res.data.pageList, page: this.state.page + 1, loader: false })
      } else {
        this.setState({ notfoundmsg: 'My Transactions Data Not Available', loader: false })
      }
      if (res.data.totalrecords > 10) {
        this.setState({ loadMoreBtnshow: true })
      } else {
        this.setState({ loadMoreBtnshow: false })
      }
      this.createjson()
    })
  }
  getAccountNumber = () => {
    getAccountNumber().then(res => {
      if (res.data.code === 200) {
        this.setState({ accountNo: res.data.response.replaceAll('*', 'X'), loader: false })
      }
    })
  }
  getPayType = empid => {
    getPaymentType(empid)
      .then(res => {
        if (res && res.data) {
          this.setState({
            paymentType: res.data.response.type
          })
        }
      })
      .catch()
  }
  getPaymentData = async () => {
    return getRecurringDateData()
      .then(res => {
        if (res && res.data) {
          const paymentDatamodel = res.data.response;
          this.setState(prevState => ({
            paymentData: res.data.response,
            paymentDatamodel,
            selectedBillingDay: prevState.selectedBillingDay === '' && paymentDatamodel.draftDay !== undefined ? paymentDatamodel.draftDay : prevState.selectedBillingDay,
          }), () => {
            this.getRecurringDay()
          })
        }
      })
      .catch()
  }
  getCardEnable = () => {
    let client_id = localStorage.getItem('CLIENT_ID')

    getCardEnableData(client_id, 'MyTransaction').then(res => {
      console.log('getCardEnableData=====', res.data.response.enable)

      if (res.data.response.enable == 'true' || res.data.response.enable == true) {
        this.setState({ tempNotAvailableModal: true })
      }
    })
  }

  callapiLoadmore() {
    this.setState({ loader: true })
    if (localStorage.getItem('SOURCE') === 'NEO') {
      getNeoTransactionMobile(this.state.page).then(res => {
        var resnew = res.data.pageList
        var data = this.state.response
        var newdata = data.concat(resnew)

        this.setState({ response: newdata, page: this.state.page + 1, loader: false })
        if (res.data.totalrecords === newdata.length) {
          this.setState({ loadMoreBtnshow: false })
        } else {
          this.setState({ loadMoreBtnshow: true })
        }
        this.createjson()
      })
    } else {
      MobilegetTransactionData(this.state.page).then(res => {
        var resnew = res.data.response
        var data = this.state.response
        var newdata = data.concat(resnew)

        if (res.data.response[0].totalRecord === newdata.length) {
          this.setState({ loadMoreBtnshow: false })
        } else {
          this.setState({ loadMoreBtnshow: true })
        }

        this.setState({ response: newdata, loader: false, page: this.state.page + 1 })
        this.createjson()
      })
    }
  }

  onCloseTempModal = () => {
    this.setState({ tempNotAvailableModal: false })
    window.location.href = '/'
  }
  createjson() {
    // var newobject = {};
    var formatredjson = []
    this.state.response.map((item, i) => {
      // console.log("crate json call=============",item.transactionId)
      var newobject = {}
      newobject.ExpenseNumberLabel = 'Transaction ID'
      newobject.ExpenseNumberVal = item.transactionId ? item.transactionId : item.transaction_id

      newobject.DateOfServiceLabel = 'Transaction Date'
      newobject.DateOfServiceVal = item.createdDate ? item.createdDate : item.transaction_date

      newobject.statusClass = item.authorizationMessage ? item.authorizationMessage : item.authorization_message
      newobject.status = item.authorizationMessage ? item.authorizationMessage : item.authorization_message

      newobject.ProviderLabel = 'Payment Method'
      newobject.ProviderVal = item.paymentMethod ? item.paymentMethod : item.type

      newobject.ChargedLabel = 'Total Amount'
      newobject.ChargedVal = item.transactionAmount ? item.transactionAmount : item.transaction_amount

      /*if(item.transactionAmount || item.transaction_amount){
          newobject.ChargedLabel= "Total Amount";
          newobject.ChargedVal= item.transactionAmount ? item.transactionAmount : item.transaction_amount;
        }else{
          newobject.ChargedLabel= "Total Amount";
          newobject.ChargedVal= "NA";
        }*/
      newobject.PaidLabel = ''
      newobject.PaidVal = ''

      var innerobject = {
        MemberLabel: 'Monthly Share Contribution',
        MemberVal: item.monthlyShare ? item.monthlyShare : item.monthly_share,
        PaidDateLabel: 'UHF Monthly Membership Fee',
        PaidDateVal: item.uhfMonthlyFee ? item.uhfMonthlyFee : item.ufh_monthly_fee,
        EOSLabel: '',
        RepricingDiscountLabel: 'Application Fee',
        RepricingDiscountVal: item.applicationFee ? item.applicationFee : item.application_fee,
        IneligibleAmountLabel: '',
        IneligibleAmountVal: '',
        NonSharableAmountLabel: 'Refund Amount',
        NonSharableAmountVal: item.refundAmount ? item.refundAmount : 'NA',
        ConsultationFeeLabel: 'Refund Description',
        ConsultationFeeVal: item.refundDescription ? item.refundDescription : 'NA',
        SharingPercentageLabel: '',
        SharingPercentageVal: ''
      }

      newobject.MoreDetail = innerobject
      // console.log("New Object is=============",newobject)

      formatredjson = formatredjson.concat(newobject)

      // console.log("=====formated json state os=============",formatredjson)
    })

    this.setState({ formatedjsonData: formatredjson })
  }

  gotoPayement() {
    this.props.history.push('/MobileTransaction')
  }

  openDraftDayModal = () => {
    // Validation: If paidThroughDate < today, show info modal, else continue
    const paidThroughDate = this.state.paymentData?.paidThroughDate;
    const today = moment.utc().startOf('day');
    console.log('openDraftDayModal paymentData:', this.state.paymentData);
    console.log('paidThroughDate:', paidThroughDate);
    console.log('today:', today.toISOString());
    if (paidThroughDate && moment.utc(paidThroughDate).isBefore(today, 'day')) {
      this.setState({
        openChangeBillingModal: true,
        draftDayModal: false
      });
      return;
    }
    const daysRange = Array.from({ length: 16 }, (_, i) => i)
    this.setState({
      openChangeBillingModal: false,
      draftDayModal: true,
      currentMonthDays: daysRange,
      currentMonthName: '',
    })
  }

  handleBillingDayChange = (val, isValid, parentObj) => {
    if (isValid) {
      let nextRecurringDate = '';
      const { paymentDatamodel } = this.state;
      if (
        paymentDatamodel &&
        paymentDatamodel.coverageDate &&
        paymentDatamodel.paymentNumber !== undefined &&
        val !== ''
      ) {
        const nextDate = moment(paymentDatamodel.coverageDate)
        .subtract(val, 'days')
        .add(paymentDatamodel.paymentNumber, 'months')
        nextRecurringDate = nextDate.format('MMM DD, YYYY');
      }
      this.setState({ selectedBillingDay: val, nextRecurringDate });
    } else {
      this.setState({ selectedBillingDay: '', nextRecurringDate: '' });
    }
  }

  submitBillingDayChange = async () => {
    if (!this.state.selectedBillingDay) {
      this.setState({
        tempNotAvailableModal: true,
        responseText: 'Please select a billing day.'
      })
      return
    }
    
    this.setState({ loader: true })
    // Vera (DISTRIBUTION PLATFORM) members' billing date lives in distributionPaymentService
    const apiUrl = process.env.REACT_APP_NEW_BASE_URL_AGENT_DETAIL + (isVeraMember() ? 'distributionPaymentService' : 'uhfpaymentService') + '/api/v1/subscriptions/billingDate';
    const payload = {
      // Vera members: "2000000007-UHF" -> 2000000007
      source: isVeraMember() ? Number(String(this.state.sourceCode).split('-')[0]) : this.state.sourceCode,
      changeType: 'DRAFT_DAY',
      updateBy: localStorage.getItem('userMail'),
      draftDay: String(this.state.selectedBillingDay),
      changeRequestPortal: 'MemberPortal',
    };
    try {
      const res = await axios.put(apiUrl, payload, {
        headers: { 'Content-Type': 'application/json' },
      });
      const { status, message, statusCode } = res.data || {};
      let apiMessage = '';
      if (statusCode === 200) {
        apiMessage = message;
      } else if (statusCode === 202) {
        apiMessage = message ;
      } else if (statusCode === 500) {
        apiMessage = message;
      } else {
        apiMessage = message;
      }
      this.setState({
        tempNotAvailableModal: true,
        draftDayModal: false,
        loader: false,
        responseText: apiMessage,
      });
    } catch (err) {
      let apiMessage = 'Something went wrong, please contact the administrator';
      if (err.response && err.response.data) {
        const { status, message, statusCode } = err.response.data;
        if (message) {
          apiMessage = message;
        } else if (err.response.data.errors && Array.isArray(err.response.data.errors)) {
          apiMessage = err.response.data.errors[0];
        }
      }
      this.setState({
        tempNotAvailableModal: true,
        loader: false,
        draftDayModal: false,
        responseText: apiMessage,
      });
    }
  }

  handleCloseDraftDayModal = () => {
    this.setState({
      draftDayModal: false,
    })
    window.location.reload();
  }

  handleCloseResponseModal = () => {
    this.setState({
      tempNotAvailableModal: false,
      responseText: ""
    })
    window.location.reload()
  }

  render() {
    // var x=this.state.formatedjsonData
    const { formatedjsonData } = this.state
    // console.log("====xxxxxxxxxxxxxxxxxx=============",x)
    return (
      <div className="">
        {this.state.loader ? <CommonLoader /> : null}
        <MobileHeader name="My Payments" />
        {/* ------------------------------------------------ */}
        {this.state.formatedjsonData ? (
          <div className="mobileCommonBody">
            <Accordion expanded={this.state.expanded === 'panel1'} onChange={this.panelhandleChange('panel1')}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <span className="labelRECENTTRANSACTIONS">RECENT TRANSACTIONS</span>
              </AccordionSummary>
              <AccordionDetails>
                <div>
                  <div style={{ marginBottom: formatedjsonData.length >= 3 ? '51px' : 0 }}>
                    <SimpleAccordion data={formatedjsonData} />
                    {this.state.loadMoreBtnshow ? (
                      <div className="loadMoreWrapper">
                        <button className="loadMoreBtn" onClick={() => this.callapiLoadmore()}>
                          Load More
                        </button>
                      </div>
                    ) : null}
                  </div>
                  {this.state.notfoundmsg && (
                    <div style={{ padding: '180px 70px', textAlign: 'center' }} className="mobile_data_not_found">
                      {this.state.notfoundmsg}
                    </div>
                  )}
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion expanded={this.state.expanded === 'panel2'} onChange={this.panelhandleChange('panel2')} >
              <AccordionSummary2 expandIcon={<ExpandMoreIcon />} aria-controls="panel2a-content" id="panel2a-header">
                <span className="labelRECENTTRANSACTIONS">PAYMENT INFORMATION</span>
              </AccordionSummary2>
              <AccordionDetails2 style={{ marginBottom: 0 }}>
                <div style={{ margin: 32 }}>
                  <span class="TitleCurrentPaymentMethod">Current Payment Method</span>
                  <br />
                  <span class="numberPaymentMethod">{localStorage.getItem('SOURCE') === 'NEO'?"N/A":this.state.paymentType == 'Credit Card' ? 'Credit Card' : 'ACH'}</span>
                  <br />
                  <div style={{ marginTop: '63px' }}>
                    <table className="Last_4_digit">
                      <td className="td_style1">Account Number currently on file</td>
                      <td className="td_style" style={{ verticalAlign: 'middle' }}>
                        {this.state.accountNo}
                      </td>
                    </table>
                  </div>
                  <br />
                  <Button variant="secondary" onClick={() => this.gotoPayement()} class="newblueActionBtn">
                    CHANGE PAYMENT METHOD
                  </Button>
                  <hr />
                  <div>
                    <span class="TitleCurrentPaymentMethod">Next Payment Due Date</span>
                    <br />
                    <span class="numberPaymentMethod">{localStorage.getItem('SOURCE') === 'NEO'?"N/A":moment(this.state.paymentData.recurringDate).format('MMM DD YYYY')}</span>
                    <div>
                      <br />
                      <Button variant="secondary" onClick={() => this.openDraftDayModal()} class="newblueActionBtn">
                        CHANGE BILLING DATE
                      </Button>
                    </div>
                  </div>
                </div>
                {/* </div> */}
              </AccordionDetails2>
            <ChatIcon showAIChatIcon={true} />
              <ChatIcon shiftup={false} setAI={() => this.setState({ isAI: true })} />
            </Accordion>
          </div>
        ) : null}
        {/* ------------------------------------------------ */}
        {/* <div className="Bottom-Blue">
          <Grid container>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
              <Button variant="secondary" onClick={() => this.gotoPayement()} class="mytransaction_changepaymentbutton">
                CHANGE PAYMENT METHOD
              </Button>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'center', marginTop: 10 }}>
              <Button variant="secondary" onClick={() => this.openDraftDayModal()} class="mytransaction_changepaymentbutton">
                CHANGE BILLING DATE
              </Button>
            </Grid>
          </Grid>
        </div> */}

        <Modal size="small" show={this.state.openChangeBillingModal} onHide={() =>this.setState({openChangeBillingModal:false})} centered backdrop="static">
          <Modal.Header>
            <Modal.Title style={{
                          fontFamily:"Roboto",
                          paddingBottom:"-10px",
                          fontWeight:"500", 
                          fontSize:"18px", 
                          fontStretch:"normal", 
                          fontStyle:"normal",
                          lineHeight:1,
                          letterSpacing:"0.15px",
                          textAlign:"center",
                          color:"#2e3192"}}>
                          Billing Details</Modal.Title>
            <IconButton aria-label="close" onClick={() =>this.setState({openChangeBillingModal:false})} style={{ marginTop: '-13px' }}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>
          <Modal.Body>
            <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <span style={{ textAlign: 'center', fontSize: '16px', fontWeight: '400' }}>
                  To change your billing date, call Member Services team at : {localStorage.getItem('CONTACT_NUMBER')} , Monday through
                  Friday 8:00 am to 8:00 pm CST.
                </span>
              </Grid>
          </Modal.Body>
          <Modal.Footer>
            <div style={{flexDirection: 'row', width: '90vw', display: 'flex',}}>
            {/* <Button variant="secondary" onClick={() =>this.openDraftDayModal()} class="ButtonBG">
            PROCEED
            </Button> */}
            <Button variant="secondary" onClick={() =>this.setState({openChangeBillingModal:false})} class="ButtonBG">
              OK
            </Button>
            </div>
          </Modal.Footer>
        </Modal>

        {/* Billing Date Change Modal */}
        {localStorage.getItem('SOURCE') === 'NEO' ? (
          <Modal size="small" show={this.state.draftDayModal} onHide={this.handleCloseDraftDayModal} centered backdrop={false} keyboard={true} style={{ zIndex: 1050 }}>
            <Modal.Header>
              <Modal.Title style={{
                          fontFamily:"Roboto",
                          paddingBottom:"-10px",
                          fontWeight:"500", 
                          fontSize:"18px", 
                          fontStretch:"normal", 
                          fontStyle:"normal",
                          lineHeight:1,
                          letterSpacing:"0.15px",
                          textAlign:"center",
                          color:"#2e3192"}}>
                          Billing Details</Modal.Title>
              <IconButton aria-label="close" onClick={this.handleCloseDraftDayModal} style={{ marginTop: '-13px' }}>
                <CloseIcon />
              </IconButton>
            </Modal.Header>
            <Modal.Body>
              <Grid container direction="row" justify="space-between" alignItems="flex-start">
                <span style={{ textAlign: 'center', fontSize: '16px', fontWeight: '400' }}>
                  To change your billing date, call Member Services team at : {localStorage.getItem('CONTACT_NUMBER')} , Monday through
                  Friday 8:00 am to 8:00 pm CST.
                </span>
              </Grid>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={this.handleCloseDraftDayModal} class="ButtonBG">
                OK
              </Button>
            </Modal.Footer>
          </Modal>
        ) : (
          <Modal size="small" show={this.state.draftDayModal} onHide={this.handleCloseDraftDayModal} centered backdrop={false} keyboard={true} style={{ zIndex: 1050 }}>
            <Modal.Header>
              <Modal.Title style={{fontFamily:"Roboto", paddingBottom:"-10px", fontWeight:"500", fontSize:"16px"}}>Choose When You Want To Be Charged</Modal.Title>
              <IconButton aria-label="close" onClick={this.handleCloseDraftDayModal} style={{ marginTop: '-13px' }}>
                <CloseIcon />
              </IconButton>
            </Modal.Header>

            <Modal.Body style={{ maxHeight: '400px', overflowY: 'visible', paddingBottom: '20px' }}>
              {this.state.loader ? <CommonLoader /> : null}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <p style={{ fontSize: '14px', fontWeight: '500', marginBottom: '0px' }}>
                    To make it easier for you to plan your cash flow, you can decide when your monthly payment is processed.
                    Please select how many days before payment due date, you would like your account to be charged.
                  </p>
                </Grid>
                <Grid item xs={12} style={{ position: 'relative' }}>
                  <CommonDropDwn
                    setChild={this.handleBillingDayChange.bind(this)}
                    name={'BillingDay'}
                    label={'Select Day'}
                    value={this.state.selectedBillingDay}
                    disable={false}
                    style={{
                      ...customStyle.dropDown,
                      fontSize: '1rem',
                      padding: '12px 14px',
                      margin: '8px 0',
                      minHeight: '44px',
                    }}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 300,
                          width: 100,
                          fontSize: '1rem',
                          padding: '8px',
                          margin: '5px',
                          borderRadius: 8,
                          zIndex: 9999,
                        },
                      },
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                      },
                      getContentAnchorEl: null,
                    }}
                    fieldType={'dropDwn'}
                    helperMsg={'Select billing day'}
                    List={this.state.currentMonthDays}
                    parentDetails={{ label: 'billingDay' }}
                  ></CommonDropDwn>
                
                  <div style={{ margin: '16px 0' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 4 }}>
                      <span style={{ fontWeight: 500, fontSize: '13px' }}>Effective Date:</span>
                      <span style={{ background: '#f0f2fa', borderRadius: 6, padding: '4px 12px', fontWeight: 600, fontSize: 14 }}>
                        {this.state.paymentDatamodel && this.state.paymentDatamodel.coverageDate ? moment(this.state.paymentDatamodel.coverageDate).format('MMM DD, YYYY') : 'N/A'}
                      </span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                      <span style={{ fontWeight: 500, fontSize: '13px' }}>Next Payment Date:</span>
                      <span style={{ background: '#f0f2fa', borderRadius: 6, padding: '4px 12px', fontWeight: 600, fontSize: 14 }}>
                        {this.state.nextRecurringDate
                          ? this.state.nextRecurringDate
                          : (this.state.paymentDatamodel && this.state.paymentDatamodel.recurringDate
                              ? moment(this.state.paymentDatamodel.recurringDate).format('MMM DD, YYYY')
                              : 'N/A')}
                      </span>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Modal.Body>

            {/* Error message and submit button logic for next payment date check */}
            {this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
              (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? (
                <div style={{ display: 'flex', alignItems: 'center', color: 'red', fontWeight: 500, margin: '-35px 0 0 0', textAlign: 'left', padding: 8 }}>
                  <InfoOutlinedIcon style={{ color: 'red', marginRight: 8, fontSize: 24 }} />
                  <span>Next payment date is earlier than today. Please select a future date.</span>
                </div>
              ) : null}
            <Modal.Footer style={{ justifyContent: 'flex-end', display: 'flex' }}>
              <Button variant="secondary" onClick={this.handleCloseDraftDayModal} class="ButtonBG" style={{ marginRight: '10px' }}>
                CANCEL
              </Button>
              <Button 
                variant="primary" 
                onClick={this.submitBillingDayChange} 
                className={
                  `ButtonBG${
                    this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))
                      ? ' Mui-disabled' : ''
                  }`
                }
                disabled={this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                  (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0))}
                style={{
                  opacity: this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? 0.5 : 1,
                  pointerEvents: this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? 'none' : 'auto',
                  backgroundColor: '#2e3192',
                  color: '#fff',
                  borderRadius: '30px',
                  fontWeight: 600,
                  fontSize: '18px',
                  width: '150px',
                  height: '40px',
                  margin: 0,
                  boxShadow: 'none',
                  textTransform: 'uppercase',
                  letterSpacing: '2px',
                  fontFamily: 'Roboto, Arial, Helvetica, sans-serif',
                  display: 'inline-block',
                  ...(this.state.draftDayModal && this.state.selectedBillingDay && this.state.nextRecurringDate &&
                    (new Date(this.state.nextRecurringDate).setHours(0,0,0,0) <= new Date().setHours(0,0,0,0)) ? {
                      backgroundColor: '#e0e0e0',
                      color: '#bdbdbd',
                      cursor: 'not-allowed',
                    } : {})
                }}
              >
                SUBMIT
              </Button>
            </Modal.Footer>
          </Modal>
        )}


        <Modal size="small" show={this.state.tempNotAvailableModal} onHide={this.handleCloseResponseModal} centered backdrop="static">
          <Modal.Header>
            <Modal.Title style={{
                          fontFamily:"Roboto",
                          paddingBottom:"-10px",
                          fontWeight:"500", 
                          fontSize:"18px", 
                          fontStretch:"normal", 
                          fontStyle:"normal",
                          lineHeight:1,
                          letterSpacing:"0.15px",
                          textAlign:"center",
                          color:"#2e3192"}}>
                          Billing Details</Modal.Title>
            <IconButton aria-label="close" onClick={this.handleCloseResponseModal} style={{ marginTop: '-13px' }}>
              <CloseIcon />
            </IconButton>
          </Modal.Header>

          <Modal.Body>
            <b>{this.state.responseText}</b>
          </Modal.Body>

          <Modal.Footer>
          <div style={{flexDirection: 'row', justifyContent:'flex-start', width: "66vw"}}>
          <Button variant="secondary" onClick={this.handleCloseResponseModal} class="ButtonBG">
              OK
            </Button>
          </div>
          </Modal.Footer>
        </Modal>

        <Modal1 visible={false} effect="fadeInUp">
          <div style={{ width: '80vw', height: '38vw' }}>
            <div className="tempModalTxt">
              We’re facing some technical difficulties, due to which this feature is currently unavailable. For support, call Member
              Services at {localStorage.getItem('CONTACT_NUMBER')}, Monday through Friday, 8.00am to 8.00pm CST.
            </div>

            <div className="mqalert_button_div">
              <NextButton
                variant="contained"
                class="yellow_popup_caption_button"
                onClick={this.onCloseTempModal}
                style={{
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                  paddingTop: '0.5rem',
                  paddingBottom: '0.5rem',
                  height: '37px',
                  backgroundColor: '#2e3192',
                  borderRadius: '20px',
                  color: '#fff',
                  fontWeight: 500
                }}
              >
                CLOSE
              </NextButton>
            </div>
          </div>
        </Modal1>
        {/* {this.state.expanded === "panel2" && <ChatIcon openChat={() => console.log('')} shiftup={false} />} */}
        {!this.state.loader && this.state.expanded === 'panel2' && (
          <div style={{ bottom: '10vh', position: 'relative' }}>
            <MobCopyright />
          </div>
        )}
        <div class="fixed-bottom">
          <MobileFooter />
        </div>{' '}

        <Modal1 visible={this.state.isAI} width="90%" effect="fadeInUp">
          <div style={{ width: '90vw' }}>
            <div class="mqalert_modal_text">
              This service is currently offline. Please try again later.
            </div>
            <br />
            <div class="mqalert_button_div">
              <button className="mqalert_button" onClick={() => this.setState({ isAI: false })}>
                OK
              </button>
            </div>
          </div>
        </Modal1>
      </div>
    )
  }
  panelhandleChange = panel => (event, expanded) => {
    this.setState({ expanded: expanded ? panel : this.state.expanded === 'panel1' ? 'panel2' : 'panel1' }, () => {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    })
  }
  getRecurringDay = () => {
    if (this.state.paymentData.recurringDate) {
      let date = new Date()
      let dateDay = date.getDate()
      let dateMonth = date.getMonth()
      let dateYear = date.getFullYear()
      if (parseInt(moment(this.state.paymentData.recurringDate).date()) < dateDay) {
        if (dateMonth === 12) {
          dateYear += 1
          dateMonth = 1
        } else {
          dateMonth += 1
        }
        dateDay = moment(this.state.paymentData.recurringDate).date()
      }
      return moment(this.state.paymentData.recurringDate).format('MMMM DD, YYYY')
    } else {
      return ''
    }
  }
}
const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    padding: '0px',
    '&:not(:last-child)': {
      borderBottom: 0
    },
    '&:before': {
      display: 'none'
    },
    '&$expanded': {
      margin: 'auto'
    }
  },
  expanded: {}
})(MuiAccordion)

const AccordionSummary = withStyles({
  root: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 49,
    position: 'fixed',
    zIndex: 100,
    width: '100%',
    paddingLeft: '24px',
    paddingRight: '5px',
    '&$expanded': {
      minHeight: 12
    }
  },

  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary)

const AccordionDetails = withStyles(theme => ({
  root: {
    padding: 0,
    marginTop: 45,
    marginBottom: '50vh'
  }
}))(MuiAccordionDetails)

const AccordionSummary2 = withStyles({
  root: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: 0,
    minHeight: 49,
    width: '100%',
    zIndex: 1031,
    position: 'fixed',
    paddingLeft: '24px',
    paddingRight: '5px',
    bottom: '10vh',
    '&$expanded': {
      bottom: '100%',
      top: 53,
      marginTop: 52, //48
      minHeight: 49
    }
  },
  content: {
    '&$expanded': {
      margin: '12px 0'
    }
  },
  expanded: {}
})(MuiAccordionSummary)

const AccordionDetails2 = withStyles(theme => ({
  root: {
    padding: 0,
    marginTop: 75,
    marginBottom: '23vh'
  }
}))(MuiAccordionDetails)
